import { Injectable } from '@angular/core';

/**
 *  Shared Across APP Utilities
 *
 */
@Injectable()
export class UtilityService {

  // constant for swipe action: left or right
  public static SWIPE_ACTION = {
    LEFT: 'swipeleft',
    RIGHT: 'swiperight',
    UP: 'swipeup',
    DOWN: 'swipedown'
  };

  constructor() { }

  public static isEmptyObject(obj: any) {
    return (obj && (Object.keys(obj).length === 0));
  }

  public static getRandomInt(min: number, max: number) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  /**
   * creates a unique uuid
   * Note: might not be completely unique, as it's based on randomization rather than time stamps
   * @returns random UUID
   */
  public static createUUID() {
    // http://www.ietf.org/rfc/rfc4122.txt
    const s = [];
    const hexDigits = '0123456789abcdef';
    for (let i = 0; i < 36; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = '4';  // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] && 0x3) || 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = '-';

    const uuid = s.join('');
    return uuid;
  }
}
